import { render, staticRenderFns } from "./SeloModal.vue?vue&type=template&id=ffbe4384&scoped=true"
import script from "./SeloModal.vue?vue&type=script&lang=js"
export * from "./SeloModal.vue?vue&type=script&lang=js"
import style0 from "./SeloModal.vue?vue&type=style&index=0&id=ffbe4384&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbe4384",
  null
  
)

export default component.exports